"use client";

import React, { useState } from "react";
import { Act1TheBusiness } from "./Act1TheBusiness";
import { Act2WhatWeBuild } from "./Act2WhatWeBuild";
import { Act3ProductGallery } from "./Act3ProductGallery";
import { Act35CaseStudies } from "./Act35CaseStudies";
import { Act4HowWeEngineer } from "./Act4HowWeEngineer";
import { Act4Boardroom } from "./Act4Boardroom";
import { ContextualDiscoveryModal, DiscoveryCategory } from "./ContextualDiscoveryModal";

export const StoryExperience: React.FC = () => {
  const [isDiscoveryOpen, setIsDiscoveryOpen] = useState(false);
  const [discoveryCategory, setDiscoveryCategory] = useState<DiscoveryCategory>("website");

  const handleOpenDiscovery = (category: DiscoveryCategory = "custom") => {
    setDiscoveryCategory(category);
    setIsDiscoveryOpen(true);
  };

  return (
    <div className="w-full flex flex-col flex-1 bg-[#F8F8F6] text-[#111318] overflow-x-hidden relative">
      {/* 1. ACT 1 — THE BUSINESS REALITY (Outside Arrival -> Reception -> The Problem -> Escalator) */}
      <Act1TheBusiness onOpenDiscovery={handleOpenDiscovery} />

      {/* 3. ACT 2 — WHAT WE BUILD (Studio 01 Web -> Studio 02 Mobile -> Studio 03 CRM/ERP) */}
      <Act2WhatWeBuild onOpenDiscovery={handleOpenDiscovery} />

      {/* 4. ACT 3 — WHAT WE'VE BUILT (The Product Gallery: DineEngage, PharmaEngage, Johnson CRM) */}
      <Act3ProductGallery />

      {/* 5. ACT 3.5 — CLIENT SYSTEMS CASE STUDIES (Apex Logistics, Dentin Healthcare, Horizon Properties) */}
      <Act35CaseStudies />

      {/* 6. ACT 4 — HOW WE ENGINEER (7-Stage Process & Full-Stack Blueprint) */}
      <Act4HowWeEngineer />

      {/* 7. ACT 5 — THE BOARDROOM (Quiet glass meeting room & consultation) */}
      <Act4Boardroom onOpenDiscoveryModal={handleOpenDiscovery} />

      {/* 8. Contextual Discovery Modal */}
      <ContextualDiscoveryModal
        isOpen={isDiscoveryOpen}
        onClose={() => setIsDiscoveryOpen(false)}
        initialCategory={discoveryCategory}
      />
    </div>
  );
};
